import { useEffect } from "react";

export const useOnClickOutside = (ref, handler, excludedClassNames = []) => {
  useEffect(() => {
    const listener = event => {
      const eventPath = event?.composedPath();

      // Do nothing if clicking ref's element or descendent elements
      if (
        !ref.current ||
        ref.current.contains(event.target) ||
        excludedClassNames.some(excludedClassName =>
          eventPath?.reduce(
            (acc, path) => acc || path?.classList?.contains(excludedClassName),
            false
          )
        )
      ) {
        return;
      }
      handler(event);
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
};
